import {
  clearLiveBridgeSession,
  loadLiveBridgeSession,
  saveLiveBridgeSession
} from "./liveBridgeSession";

export function saveSession(session) {
  saveLiveBridgeSession(session);
}

export function loadSession() {
  return loadLiveBridgeSession();
}

export function clearSession() {
  clearLiveBridgeSession();
}
